import type { PostFetchGuard, PostFetchGuardContext } from '../types'

export const runPostFetchGuards = (
  context: PostFetchGuardContext,
  guards: PostFetchGuard[]
): any[] => {
  let nextData = context.componentsData || []
  for (const guard of guards) {
    nextData = guard({ ...context, componentsData: nextData })
  }
  return nextData
}
